var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.5936 0H1.40273C0.627148 0 0 0.612305 0 1.36934V17.627C0 18.384 0.627148 19 1.40273 19H17.5936C18.3691 19 19 18.384 19 17.6307V1.36934C19 0.612305 18.3691 0 17.5936 0ZM5.63691 16.1908H2.8166V7.12129H5.63691V16.1908ZM4.22676 5.88555C3.32129 5.88555 2.59023 5.15449 2.59023 4.25273C2.59023 3.35098 3.32129 2.61992 4.22676 2.61992C5.12852 2.61992 5.85957 3.35098 5.85957 4.25273C5.85957 5.15078 5.12852 5.88555 4.22676 5.88555ZM16.1908 16.1908H13.3742V11.7822C13.3742 10.732 13.3557 9.37754 11.9084 9.37754C10.4426 9.37754 10.2199 10.5242 10.2199 11.708V16.1908H7.40703V7.12129H10.1086V8.36074H10.1457C10.5205 7.64824 11.4408 6.89492 12.8102 6.89492C15.6639 6.89492 16.1908 8.77266 16.1908 11.2145V16.1908Z","fill":"white"}));
}

Linkedin.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
